// @ts-nocheck
import { Mark } from 'tiptap';
import { toggleMark, markInputRule, markPasteRule } from 'tiptap-commands';
import { handleRightArrow } from '../helpers';

export class Code extends Mark {
  get name() {
    return 'code';
  }

  get schema() {
    return {
      excludes: '_',
      parseDOM: [{ tag: 'code' }],
      toDOM: () => ['code', { class: 'inline-code' }, 0],
    };
  }

  keys({ type }) {
    return {
      'Mod-`': toggleMark(type),
      [`ArrowRight`]: handleRightArrow(type),
    };
  }

  commands({ type }) {
    return () => toggleMark(type);
  }

  inputRules({ type }) {
    return [markInputRule(/(?:`)([^`]+)(?:`)$/, type)];
  }

  pasteRules({ type }) {
    return [markPasteRule(/(?:`)([^`]+)(?:`)/g, type)];
  }
}
